import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(ITextElement) {
    (function(ITextElementStyle) {
        ITextElementStyle.build = function(partial) {
            return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
        };
    })(ITextElement.ITextElementStyle || (ITextElement.ITextElementStyle = {}));
    (function(TextDecorator) {
        TextDecorator["TEXT_DECORATOR_UNKNOWN"] = "TEXT_DECORATOR_UNKNOWN";
        /**
     * SECTION_HEADER, PAGE_HEADER, DISPLAY_M, DISPLAY_L, DISPLAY_XL
     * don't have emphasis.
     */ TextDecorator["EMPHASIS"] = "EMPHASIS";
        TextDecorator["LINK"] = "LINK";
        TextDecorator["STRIKE_THROUGH"] = "STRIKE_THROUGH";
    })(ITextElement.TextDecorator || (ITextElement.TextDecorator = {}));
    ITextElement.build = function(partial) {
        return _object_spread({
            suffix_c_t_a_on_click: []
        }, partial !== null && partial !== void 0 ? partial : {});
    };
})(ITextElement || (ITextElement = {}));
export var ITextElement;
